// ── Catégories IA haute-niveau ─────────────────────────────────────────────────
export const IA_CATEGORIES = {
  Animal:           { key: 'Animal',          color: '#26b36a', emoji: '🐾' },
  Construction:     { key: 'Construction',    color: '#e07b00', emoji: '🏗️' },
  Domestique:       { key: 'Domestique',      color: '#6a0572', emoji: '🏠' },
  Musique:          { key: 'Musique',         color: '#e91e63', emoji: '🎵' },
  Nature:           { key: 'Nature',          color: '#4caf50', emoji: '🌿' },
  Urbain:           { key: 'Urbain',          color: '#00838f', emoji: '🏢' },
  'Voix humaine':   { key: 'Voix humaine',    color: '#0077b6', emoji: '🗣️' },
  Véhicule:         { key: 'Véhicule',        color: '#c0392b', emoji: '🚘' },

  // ── Outils / Construction ──────────────────────────────────────────────────
  'Marteau-piqueur':              { color: '#e07b00', emoji: '⛏️' },
  'Marteau':                      { color: '#e07b00', emoji: '🔨' },
  'Sciage':                       { color: '#e07b00', emoji: '🪚' },
  'Tronçonneuse':                 { color: '#e07b00', emoji: '🪚' },
  'Perceuse':                     { color: '#e07b00', emoji: '🛠️' },
  'Perçage':                      { color: '#e07b00', emoji: '🛠️' },
  'Perceuse dentaire':            { color: '#e07b00', emoji: '🦷' },
  'Outil électrique':             { color: '#e07b00', emoji: '⚡' },
  'Ponçage':                      { color: '#e07b00', emoji: '🪵' },
  'Limage (râpe)':                { color: '#e07b00', emoji: '🛠️' },
  'Râpage':                       { color: '#e07b00', emoji: '🛠️' },
  'Tondeuse à gazon':             { color: '#e07b00', emoji: '🌿' },
  'Coupe':                        { color: '#6b4226', emoji: '🪓' },
  'Hachage':                      { color: '#6b4226', emoji: '🔪' },

  // ── Moteurs ───────────────────────────────────────────────────────────────
  'Moteur lourd (basse fréquence)':    { color: '#c0392b', emoji: '🚜' },
  'Moteur moyen (fréquence moyenne)':  { color: '#c0392b', emoji: '🚧' },
  'Moteur léger (haute fréquence)':    { color: '#c0392b', emoji: '🛠️' },
  'Moteur lourd':                      { color: '#c0392b', emoji: '🚜' },
  'Moteur moyen':                      { color: '#c0392b', emoji: '🚧' },
  'Moteur léger':                      { color: '#c0392b', emoji: '🛠️' },
  'Moteur':                            { color: '#c0392b', emoji: '⚙️' },
  'Cliquetis moteur':                  { color: '#c0392b', emoji: '⚙️' },
  'Cognement du moteur':               { color: '#c0392b', emoji: '⚙️' },
  'Démarrage du moteur':               { color: '#c0392b', emoji: '🔑' },
  'Ralenti':                           { color: '#c0392b', emoji: '🚜' },
  'Accélération, vrombissement':       { color: '#c0392b', emoji: '🚀' },
  'Accélération':                      { color: '#c0392b', emoji: '🚜' },

  // ── Véhicules ─────────────────────────────────────────────────────────────
  'Voiture de police (sirène)':        { color: '#c0392b', emoji: '🚓' },
  'Ambulance (sirène)':                { color: '#c0392b', emoji: '🚑' },
  'Camion de pompiers (sirène)':       { color: '#c0392b', emoji: '🚒' },
  'Grincement des roues de train':     { color: '#c0392b', emoji: '🚆' },
  'Sifflet de train':                  { color: '#c0392b', emoji: '🚆' },
  'Klaxon de train':                   { color: '#c0392b', emoji: '🚆' },
  'Wagon de train':                    { color: '#c0392b', emoji: '🚃' },
  'Train':                             { color: '#c0392b', emoji: '🚆' },
  'Métro':                             { color: '#c0392b', emoji: '🚇' },
  'Bus':                               { color: '#c0392b', emoji: '🚌' },
  'Moto':                              { color: '#c0392b', emoji: '🏍️' },
  'Avion':                             { color: '#c0392b', emoji: '✈️' },
  'Hélicoptère':                       { color: '#c0392b', emoji: '🚁' },
  'Bateau':                            { color: '#4caf50', emoji: '⛵' },
  'Camion':                            { color: '#c0392b', emoji: '🚛' },
  'Frein pneumatique':                 { color: '#c0392b', emoji: '💨' },
  'Frein à air':                       { color: '#c0392b', emoji: '💨' },
  'Klaxon pneumatique':                { color: '#c0392b', emoji: '📢' },
  'Klaxon de camion':                  { color: '#c0392b', emoji: '📢' },
  'Klaxon':                            { color: '#c0392b', emoji: '📢' },
  'Bips de recul':                     { color: '#c0392b', emoji: '🔊' },
  'Bip de recul':                      { color: '#c0392b', emoji: '🔊' },
  'Véhicule motorisé (route)':         { color: '#c0392b', emoji: '🚚' },
  'Véhicule motorisé':                 { color: '#c0392b', emoji: '🚚' },
  'Véhicule':                          { color: '#c0392b', emoji: '🚗' },
  'Grincement de pneus':               { color: '#c0392b', emoji: '🛞' },
  'Dérapage':                          { color: '#c0392b', emoji: '🛞' },
  'Bruit de circulation':              { color: '#c0392b', emoji: '🏙️' },
  'Ventilateur mécanique':             { color: '#00838f', emoji: '🌀' },

  // ── Impacts / Fracas ─────────────────────────────────────────────────────
  'Coup de feu':                       { color: '#7b2d8b', emoji: '🔫' },
  'Explosion':                         { color: '#7b2d8b', emoji: '💥' },
  'Détonation':                        { color: '#7b2d8b', emoji: '💥' },
  'Bang':                              { color: '#7b2d8b', emoji: '💥' },
  'Boum':                              { color: '#7b2d8b', emoji: '💥' },
  'Écrasement':                        { color: '#7b2d8b', emoji: '💥' },
  'Craquement':                        { color: '#7b2d8b', emoji: '🧱' },
  'Fracas':                            { color: '#7b2d8b', emoji: '💥' },
  'Cassure':                           { color: '#7b2d8b', emoji: '🧱' },
  'Bruit sourd':                       { color: '#7b2d8b', emoji: '🔨' },
  'Grincement aigu':                   { color: '#7b2d8b', emoji: '🛞' },
  'Grincement':                        { color: '#7b2d8b', emoji: '🏗️' },
  'Couinement':                        { color: '#7b2d8b', emoji: '🛞' },
  'Vrombissement':                     { color: '#7b2d8b', emoji: '⚙️' },
  'Cliquetis':                         { color: '#7b2d8b', emoji: '🔧' },
  'Grondement':                        { color: '#7b2d8b', emoji: '🔊' },
  'Raclage':                           { color: '#7b2d8b', emoji: '🧱' },
  'Raclement':                         { color: '#7b2d8b', emoji: '🧱' },
  'Frottement':                        { color: '#7b2d8b', emoji: '🪨' },
  'Claquement':                        { color: '#7b2d8b', emoji: '👊' },

  // ── Matériaux ─────────────────────────────────────────────────────────────
  'Bris de verre':                     { color: '#5bc8d4', emoji: '🪟' },
  'Verre':                             { color: '#5bc8d4', emoji: '🪟' },
  'Briser':                            { color: '#7b2d8b', emoji: '🪟' },
  'Bois':                              { color: '#6b4226', emoji: '🪵' },
  'Couper':                            { color: '#6b4226', emoji: '🪓' },
  'Éclatement':                        { color: '#6b4226', emoji: '🪵' },

  // ── Nature ────────────────────────────────────────────────────────────────
  'Alarme incendie':                   { color: '#ff5722', emoji: '🔥' },
  'Détecteur de fumée':                { color: '#ff5722', emoji: '🔥' },
  'Crépitement':                       { color: '#ff5722', emoji: '🔥' },
  'Feu':                               { color: '#ff5722', emoji: '🔥' },
  'Orage':                             { color: '#4caf50', emoji: '⛈️' },
  'Tonnerre':                          { color: '#4caf50', emoji: '⛈️' },
  'Pluie':                             { color: '#4caf50', emoji: '🌧️' },
  'Vent':                              { color: '#4caf50', emoji: '💨' },

  // ── Alarmes / Signaux ─────────────────────────────────────────────────────
  'Sirène':                            { color: '#00838f', emoji: '🚨' },
  'Alarme':                            { color: '#00838f', emoji: '🚨' },
  'Sifflet':                           { color: '#00838f', emoji: '🔊' },
  'Bip':                               { color: '#00838f', emoji: '📳' },

  // ── Animaux spécifiques ───────────────────────────────────────────────────
  "Chant d'oiseau":                    { color: '#26b36a', emoji: '🐦' },
  'Cocorico':                          { color: '#26b36a', emoji: '🐓' },
  'Aboiement':                         { color: '#26b36a', emoji: '🐕' },
  'Miaulement':                        { color: '#26b36a', emoji: '🐱' },
  'Bourdonnement':                     { color: '#26b36a', emoji: '🐝' },

  // ── Liquides ──────────────────────────────────────────────────────────────
  'Éclaboussure':                      { color: '#2196f3', emoji: '💦' },
  'Goutte':                            { color: '#2196f3', emoji: '💧' },

  // ── Présence humaine / Foule ──────────────────────────────────────────────
  'Applaudissements':                  { color: '#0077b6', emoji: '👏' },
  'Foule':                             { color: '#00838f', emoji: '👥' },
  'Marche, pas':                       { color: '#00838f', emoji: '👣' },
  'Rire':                              { color: '#0077b6', emoji: '😄' },
  'Vibration':                         { color: '#7b2d8b', emoji: '📳' },
};

export const ICON_EMOJI = {
  ...Object.fromEntries(Object.values(IA_CATEGORIES).map(({ key, emoji }) => [key ?? '', emoji])),
  diamond: null,
  circle:  '',
};

// ── Mots-clés pour la détection automatique ────────────────────────────────────
const CATEGORY_KEYWORDS = {
  // ── HIGH-LEVEL ─────────────────────────────────────────────────────────────
  Animal: [
    'animal', 'chien', 'dog', 'chat', 'cat', 'oiseau', 'bird', 'insecte', 'insect',
    'grenouille', 'frog', 'coq', 'rooster', 'vache', 'cow', 'cheval', 'horse',
    'mouton', 'sheep', 'cochon', 'porc', 'pig', 'lapin', 'rabbit', 'pigeon',
    'corbeau', 'crow', 'merle', 'abeille', 'bee', 'guêpe', 'wasp',
    'grillon', 'cricket', 'cigale', 'cicada', 'moustique', 'mosquito',
    'mouche', 'fly', 'hibou', 'owl', 'canard', 'duck', 'oie', 'goose',
    'dinde', 'turkey', 'chèvre', 'goat', 'wildlife', 'faune', 'fauna',
    'animaux domestiques', 'domestic animals', 'animaux sauvages', 'wild animals',
    'animaux d\'élevage', 'livestock', 'bovins', 'cattle', 'rongeurs', 'rodents',
    'souris', 'mouse', 'serpent', 'snake', 'baleine', 'whale', 'félins',
    'ronronnement', 'purr', 'hennissement', 'neigh', 'meuglement', 'moo',
    'bêlement', 'bleat', 'gloussement animal', 'cluck', 'gazouillis', 'chirp',
    'hululement', 'hoot', 'coassement', 'croak', 'rugissement', 'roar',
  ],
  Construction: [
    'excavatrice', 'excavateur', 'compresseur', 'béton', 'beton',
    'grue', 'crane', 'foreuse', 'bulldozer', 'travaux', 'meuleuse',
    'perforateur', 'pelleteuse', 'excavator', 'construction', 'compressor', 'chantier',
    'drilling', 'jackhammer',
  ],
  Domestique: [
    'aspirateur', 'vacuum', 'lave-vaisselle', 'dishwasher', 'machine à laver',
    'sèche-linge', 'dryer', 'four', 'oven', 'micro-onde', 'microwave',
    'réfrigérateur', 'refrigerateur', 'frigo', 'fridge', 'climatisation', 'chauffage',
    'bouilloire', 'kettle', 'cafetière', 'domestique', 'ménage', 'menage',
    'électroménager', 'electromenager', 'porte', 'door', 'sonnette', 'doorbell',
    'ding-dong', 'tiroir', 'drawer', 'vaisselle', 'dishes', 'casseroles', 'pots',
    'couvert', 'cutlery', 'robinet', 'faucet', 'tap', 'évier', 'sink',
    'baignoire', 'bathtub', 'sèche-cheveux', 'hair dryer', 'chasse d\'eau', 'toilet',
    'brosse à dents', 'toothbrush', 'fermeture éclair', 'zipper',
    'machine à coudre', 'sewing machine', 'imprimante', 'printer',
    'télévision', 'television', 'radio', 'caisse enregistreuse', 'cash register',
    'réveil', 'alarm clock', 'horloge', 'clock',
  ],
  Musique: [
    'musique', 'music', 'concert', 'guitare', 'guitar', 'piano', 'batterie', 'drums',
    'violon', 'violin', 'trompette', 'trumpet', 'flûte', 'flute', 'saxophone', 'sax',
    'orchestre', 'orchestra', 'chant', 'chanson', 'song', 'mélodie', 'melody',
    'instrument', 'basse', 'bass', 'synthé', 'synth', 'harmonica', 'accordéon',
    'clarinette', 'clarinet', 'harpe', 'harp', 'orgue', 'organ', 'percussion',
    'tambour', 'drum', 'cymbale', 'cymbal', 'banjo', 'mandoline', 'clavecin',
    'vibraphone', 'marimba', 'xylophone', 'trombone', 'violoncelle', 'cello',
    'contrebasse', 'double bass', 'ukulélé', 'sitar', 'didgeridoo', 'thérémine',
    'pop', 'hip hop', 'rock', 'jazz', 'blues', 'reggae', 'disco', 'techno',
    'classique', 'classical', 'opéra', 'opera', 'folk', 'country', 'funk', 'swing',
    'rap', 'beatbox', 'fredonnement', 'sifflement mélodique', 'whistling',
    'chorale', 'choir', 'yodel', 'mantra', 'berceuse', 'lullaby',
    'grattement de guitare', 'strum', 'pizzicato', 'roulement de tambour', 'drum roll',
  ],
  Nature: [
    'vent', 'wind', 'pluie', 'rain', 'tonnerre', 'thunder', 'orage', 'thunderstorm',
    'météo', 'weather', 'nature', 'eau', 'water', 'feu', 'fire', 'cascade', 'waterfall',
    'ruisseau', 'stream', 'ocean', 'vagues', 'waves', 'surf', 'vapeur', 'steam',
    'crépitement', 'crackle', 'feuilles', 'leaves', 'extérieur rural', 'outside rural',
    'goutte de pluie', 'raindrop', 'pluie sur surface', 'rain on surface',
    'gargouillis eau', 'gurgling', 'bruissement des feuilles', 'rustling leaves',
    'bruit de vent', 'wind noise',
  ],
  Urbain: [
    'foule', 'crowd', 'clameur', 'marché', 'market', 'restaurant', 'café',
    'bar', 'rue', 'street', 'parc', 'park', 'ville', 'city', 'urbain', 'urban',
    'ambiance', 'atmosphère', 'atmosphere', 'fête', 'festival',
    'extérieur urbain', 'outside urban', 'bruit environnemental', 'environmental noise',
    'réverbération', 'reverberation', 'écho', 'echo', 'cacophonie', 'cacophony',
    'brouhaha', 'hubbub', 'bruit de fond', 'background noise',
  ],
  'Voix humaine': [
    'voix', 'voice', 'parole', 'speech', 'discours', 'conversation', 'dialogue',
    'enfant', 'child', 'bébé', 'baby', 'cri', 'scream', 'chuchotement', 'whisper',
    'rire humain', 'laugh', 'pleur', 'cry', 'humain', 'human', 'personne', 'person',
    'narration', 'monologue', 'babillage', 'babbling', 'synthèse vocale',
    'hurlement', 'yell', 'bellow', 'gémissement', 'soupir', 'sigh',
    'respiration', 'breathing', 'ronflement', 'snoring', 'toux', 'cough',
    'éternuement', 'sneeze', 'applaudissements', 'applause', 'bavardage', 'chatter',
    'voix humaine', 'parole d\'enfant', 'enfants qui crient', 'hurlement aigu',
  ],
  Véhicule: [
    'voiture', 'car', 'tramway', 'tram', 'aéronef', 'aircraft',
    'vélo', 'bicycle', 'skateboard', 'transport', 'voilier', 'sailboat',
  ],

  // ── Sons spécifiques ──────────────────────────────────────────────────────
  'Marteau-piqueur':         ['marteau-piqueur', 'marteau piqueur', 'jackhammer', 'perforateur'],
  'Marteau':                 ['marteau', 'hammer'],
  'Sciage':                  ['sciage', 'scie', 'sawing', 'saw'],
  'Tronçonneuse':            ['tronçonneuse', 'tronconneuse', 'chainsaw'],
  'Perceuse':                ['perceuse', 'drill', 'drilling', 'percer'],
  'Perçage':                 ['perçage', 'percage'],
  'Perceuse dentaire':       ['perceuse dentaire', 'dental drill'],
  'Outil électrique':        ['outil électrique', 'outil electrique', 'power tool', 'electric tool'],
  'Ponçage':                 ['ponçage', 'poncage', 'ponceuse', 'sanding'],
  'Limage (râpe)':           ['limage', 'lime', 'râpe', 'filing', 'rasp', 'filing (rasp)'],
  'Râpage':                  ['râpage', 'rapage', 'râper'],
  'Tondeuse à gazon':        ['tondeuse', 'lawn mower', 'lawnmower'],
  'Coupe':                   ['coupe', 'chop'],
  'Hachage':                 ['hachage', 'découpe alimentaire', 'hacher', 'couteau', 'knife'],
  'Moteur lourd (basse fréquence)':    ['moteur lourd (basse fréquence)', 'heavy engine (low frequency)'],
  'Moteur moyen (fréquence moyenne)':  ['moteur moyen (fréquence moyenne)', 'medium engine (mid frequency)'],
  'Moteur léger (haute fréquence)':    ['moteur léger (haute fréquence)', 'light engine (high frequency)'],
  'Moteur lourd':            ['moteur lourd', 'basses fréquences', 'heavy engine'],
  'Moteur moyen':            ['moteur moyen', 'fréquences moyennes', 'medium engine'],
  'Moteur léger':            ['moteur léger', 'moteur leger', 'hautes fréquences', 'light engine'],
  'Cliquetis moteur':        ['cliquetis moteur', 'engine knocking'],
  'Cognement du moteur':     ['cognement', 'engine knock', 'claquement moteur'],
  'Démarrage du moteur':     ['démarrage du moteur', 'engine starting', 'engine start'],
  'Ralenti':                 ['ralenti', 'idle', 'idling', 'tick-over'],
  'Accélération, vrombissement': ['accélération, vrombissement', 'accelerating, revving', 'revving, vroom'],
  'Accélération':            ['accélération', 'acceleration', 'montée en régime', 'rev up'],
  'Moteur':                  ['moteur', 'engine', 'motor'],
  'Voiture de police (sirène)': ['voiture de police', 'police car', 'police siren'],
  'Ambulance (sirène)':      ['ambulance'],
  'Camion de pompiers (sirène)': ['camion de pompiers', 'fire engine', 'fire truck'],
  'Grincement des roues de train': ['grincement des roues de train', 'train wheels squealing'],
  'Sifflet de train':        ['sifflet de train', 'train whistle'],
  'Klaxon de train':         ['klaxon de train', 'train horn'],
  'Wagon de train':          ['wagon de train', 'railroad car', 'train wagon'],
  'Train':                   ['train'],
  'Métro':                   ['métro', 'metro', 'subway', 'underground'],
  'Bus':                     ['bus'],
  'Moto':                    ['moto', 'motorcycle'],
  'Avion':                   ['avion', 'airplane', 'fixed-wing aircraft', 'jet engine', 'réacteur', 'propeller'],
  'Hélicoptère':             ['hélicoptère', 'helicoptere', 'helicopter'],
  'Bateau':                  ['bateau', 'boat', 'navire', 'ship', 'voilier', 'kayak', 'canoe', 'motorboat'],
  'Klaxon pneumatique':      ['klaxon pneumatique', 'air horn', 'truck horn'],
  'Klaxon de camion':        ['klaxon de camion'],
  'Klaxon':                  ['klaxon', 'avertisseur', 'honking', 'vehicle horn', 'car horn'],
  'Frein pneumatique':       ['frein pneumatique', 'air brake'],
  'Frein à air':             ['frein à air', 'frein a air'],
  'Bips de recul':           ['bips de recul', 'reversing beeps'],
  'Bip de recul':            ['bip de recul', 'backup beep', 'recul'],
  'Camion':                  ['camion', 'truck', 'poids lourd', 'semi'],
  'Véhicule motorisé (route)': ['véhicule motorisé (route)', 'motor vehicle (road)'],
  'Véhicule motorisé':       ['véhicule motorisé', 'vehicule motorise', 'motorized vehicle'],
  'Grincement de pneus':     ['grincement de pneus', 'tire squeal'],
  'Dérapage':                ['dérapage', 'skidding'],
  'Bruit de circulation':    ['bruit de circulation', 'traffic noise', 'roadway noise'],
  'Ventilateur mécanique':   ['ventilateur mécanique', 'ventilateur mecanique', 'mechanical fan'],
  'Coup de feu':             ['coup de feu', 'gunshot', 'gunfire', 'machine gun', 'mitrailleuse', 'fusillade', 'artillery fire', 'cap gun', 'firecracker', 'fireworks', 'pétard'],
  'Explosion':               ['explosion', 'eruption', 'éruption', 'burst, pop', 'éclatement brusque'],
  'Détonation':              ['détonation', 'detonation', 'bang'],
  'Bang':                    ['bang'],
  'Boum':                    ['boum', 'boom'],
  'Écrasement':              ['écrasement', 'crushing'],
  'Craquement':              ['craquement', 'crack', 'snap', 'crunch'],
  'Fracas':                  ['fracas', 'smash', 'crash', 'collision', 'impact'],
  'Cassure':                 ['cassure', 'breaking', 'breakage', 'casser'],
  'Bruit sourd':             ['bruit sourd', 'thud', 'thump', 'thunk', 'clac sourd'],
  'Grincement aigu':         ['grincement aigu', 'squeal aigu'],
  'Grincement':              ['grincement', 'creak', 'screech'],
  'Couinement':              ['couinement', 'squeak', 'couiner'],
  'Vrombissement':           ['vrombissement', 'drone mécanique', 'whir', 'whirring'],
  'Cliquetis':               ['cliquetis', 'rattle', 'clatter', 'clang', 'clink', 'tintement'],
  'Grondement':              ['grondement', 'rumble', 'gronder'],
  'Raclage':                 ['raclage', 'racler', 'scrape'],
  'Raclement':               ['raclement'],
  'Frottement':              ['frottement', 'friction', 'rubbing', 'rub'],
  'Claquement':              ['claquement', 'slam', 'slap', 'smack', 'whack'],
  'Bris de verre':           ['bris de verre', 'shatter', 'voler en éclats'],
  'Verre':                   ['verre', 'glass'],
  'Briser':                  ['briser'],
  'Bois':                    ['bois', 'wood', 'timber', 'lumber'],
  'Couper':                  ['couper à coups', 'abattre', 'axe', 'hache'],
  'Éclatement':              ['éclatement', 'écharde', 'splinter'],
  'Alarme incendie':         ['alarme incendie', 'fire alarm'],
  'Détecteur de fumée':      ['détecteur de fumée', 'smoke detector', 'smoke alarm'],
  'Crépitement':             ['crépitement', 'crépiter', 'crackle fire'],
  'Feu':                     ['feu', 'fire', 'flamme', 'incendie'],
  'Orage':                   ['orage', 'thunderstorm', 'tempête'],
  'Tonnerre':                ['tonnerre', 'thunder'],
  'Pluie':                   ['pluie', 'rain', 'raindrop', 'goutte de pluie', 'pluie sur surface'],
  'Vent':                    ['vent', 'wind', 'brise', 'rafale', 'bruit de vent', 'bruissement des feuilles', 'wind noise'],
  'Sirène':                  ['sirène', 'siren', 'civil defense siren', 'corne de brume', 'foghorn'],
  'Alarme':                  ['alarme', 'alarm'],
  'Sifflet':                 ['sifflet', 'whistle', 'sifflet à vapeur', 'steam whistle'],
  'Bip':                     ['bip', 'beep', 'bleep', 'buzzer', 'ping', 'ding', 'sonnerie', 'ringtone'],
  "Chant d'oiseau":          ["chant d'oiseau", 'bird vocalization', 'bird call', 'bird song', 'gazouillis', 'chirp', 'tweet', 'squawk', 'coo', 'caw', 'hoot', 'battement d\'ailes'],
  'Cocorico':                ['cocorico', 'cock-a-doodle-doo', 'crowing'],
  'Aboiement':               ['aboiement', 'bark', 'yip', 'bow-wow', 'jappement'],
  'Miaulement':              ['miaulement', 'meow', 'caterwaul'],
  'Bourdonnement':           ['bourdonnement', 'buzz', 'buzzing'],
  'Éclaboussure':            ['éclaboussure', 'splash', 'splatter', 'slosh'],
  'Goutte':                  ['goutte', 'drip', 'trickle', 'dribble', 'filet d\'eau', 'gush', 'jaillissement'],
  'Applaudissements':        ['applaudissements', 'applause', 'clapping'],
  'Foule':                   ['foule', 'crowd', 'acclamations', 'cheering', 'enfants qui jouent'],
  'Marche, pas':             ['marche, pas', 'pas', 'footsteps', 'walk', 'shuffle', 'patter', 'course'],
  'Rire':                    ['rire', 'laughter', 'giggle', 'snicker', 'chuckle', 'gloussement rire'],
  'Vibration':               ['vibration', 'vibrating'],
};

// Ordre : sons très spécifiques d'abord, catégories larges en dernier
const SPECIFIC_SOUNDS = [
  // Outils construction
  'Marteau-piqueur', 'Tronçonneuse', 'Perceuse dentaire', 'Perceuse', 'Perçage',
  'Sciage', 'Limage (râpe)', 'Râpage', 'Ponçage', 'Outil électrique',
  'Tondeuse à gazon', 'Coupe', 'Hachage',
  // Moteurs — noms longs en premier
  'Moteur lourd (basse fréquence)', 'Moteur moyen (fréquence moyenne)', 'Moteur léger (haute fréquence)',
  'Moteur lourd', 'Moteur moyen', 'Moteur léger',
  'Cliquetis moteur', 'Cognement du moteur', 'Démarrage du moteur', 'Ralenti',
  'Accélération, vrombissement', 'Accélération', 'Moteur',
  // Véhicules d'urgence
  'Voiture de police (sirène)', 'Ambulance (sirène)', 'Camion de pompiers (sirène)',
  // Train
  'Grincement des roues de train', 'Sifflet de train', 'Klaxon de train', 'Wagon de train', 'Train',
  // Autres véhicules
  'Métro', 'Bus', 'Moto', 'Avion', 'Hélicoptère', 'Bateau',
  // Klaxons / avertisseurs
  'Klaxon pneumatique', 'Klaxon de camion', 'Klaxon',
  // Freins / recul
  'Frein pneumatique', 'Frein à air', 'Bips de recul', 'Bip de recul',
  // Véhicules génériques
  'Camion', 'Véhicule motorisé (route)', 'Véhicule motorisé',
  'Grincement de pneus', 'Dérapage', 'Bruit de circulation', 'Ventilateur mécanique',
  // Explosions / armes
  'Coup de feu', 'Explosion', 'Détonation', 'Bang', 'Boum', 'Écrasement',
  // Impacts
  'Craquement', 'Fracas', 'Cassure', 'Bruit sourd',
  'Grincement aigu', 'Grincement', 'Couinement', 'Vrombissement',
  'Cliquetis', 'Grondement', 'Raclage', 'Raclement', 'Frottement', 'Claquement',
  // Matériaux
  'Bris de verre', 'Verre', 'Briser', 'Bois', 'Couper', 'Éclatement',
  // Feu / alarmes incendie
  'Alarme incendie', 'Détecteur de fumée', 'Crépitement', 'Feu',
  // Météo
  'Orage', 'Tonnerre', 'Pluie', 'Vent',
  // Alarmes / signaux
  'Sirène', 'Alarme', 'Sifflet', 'Bip',
  // Animaux spécifiques
  "Chant d'oiseau", 'Cocorico', 'Aboiement', 'Miaulement', 'Bourdonnement',
  // Liquides
  'Éclaboussure', 'Goutte',
  // Humain spécifique
  'Applaudissements', 'Foule', 'Marche, pas', 'Rire',
  // Mécanique
  'Vibration',
];

const HIGH_LEVEL_CATEGORIES = [
  'Animal', 'Construction', 'Domestique', 'Musique', 'Nature', 'Urbain', 'Voix humaine', 'Véhicule',
];

export function detectCategory(labelText) {
  if (!labelText) return null;
  const normalized = labelText.toLowerCase().trim();

  // 1. Correspondance exacte (insensible à la casse)
  const exactMatch = Object.keys(IA_CATEGORIES).find(
    (cat) => cat.toLowerCase() === normalized
  );
  if (exactMatch) return exactMatch;

  // 2. Sons spécifiques en priorité (avant les catégories larges)
  for (const sound of SPECIFIC_SOUNDS) {
    const keywords = CATEGORY_KEYWORDS[sound] || [];
    if (keywords.some((kw) => normalized.includes(kw.toLowerCase()))) return sound;
  }

  // 3. Catégories haute-niveau
  for (const cat of HIGH_LEVEL_CATEGORIES) {
    const keywords = CATEGORY_KEYWORDS[cat] || [];
    if (keywords.some((kw) => normalized.includes(kw.toLowerCase()))) return cat;
  }

  return null;
}
